import { CloudCoreClient } from "./client"

export class CloudCoreFactory {
    private static instance: CloudCoreClient | null = null;

    private constructor() {
    }
    
    public static getInstance(): CloudCoreClient {
        if (!CloudCoreFactory.instance) {
            CloudCoreFactory.instance = new CloudCoreClient();
        }
        return CloudCoreFactory.instance;
    }

    getClient() {
        return CloudCoreFactory.instance;
    }
}